export default __webpack_public_path__ + "static/media/about.92067aa8.svg";